export const ACCORDION_ROOT = 'ACCORDION_ROOT';
